import React from "react";
import { Text as SitecoreText } from "@sitecore-jss/sitecore-jss-react"; // eslint-disable-line no-restricted-imports

export const CustomText = props => <SitecoreText {...props}/>;